"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chartEnums = void 0;
var chartEnums = exports.chartEnums = {
  // APEX: 'APEX',
  TradingView: 'Trading View',
  LightWeight: 'Trading View Light Weight'
};